import { useEffect } from 'react';
import { useOnboardingState } from '../context/OnboardingContext';

export function useOnboardingBlocker() {
  const state = useOnboardingState();

  useEffect(() => {
    if (!state.isDirty) return;

    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [state.isDirty]);
}
